import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { User } from 'src/app/model/user';
import { MyErrorStateMatcher } from 'src/app/utils/errorStateMatcher';
import { GenericClass } from 'src/app/model/genericClass';
import { Client } from 'src/app/model/client';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from 'src/app/utils/constants';
import { BehaviorSubject, firstValueFrom, Subject, Subscription, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ClientService } from 'src/app/services/client.service';
import { UsersService } from 'src/app/services/users.service';
import { ProcessService } from 'src/app/services/process.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { ActionConfirmPasswordComponent } from '../../shared/action-confirm-password/action-confirm-password.component';
import { TestQualificationTypeService } from '../../../services/testQualificationType.service';
import { TestQualificationTypeShort } from '../../../model/testQualificationType';
import { GroupTestQDataVerification } from 'src/app/model/groupTestQDataVerification';
import { MatTable } from '@angular/material/table';
import { EditReferenceDocsComponent } from '../../shared/edit-reference-docs/edit-reference-docs.component';
import * as _ from 'lodash';
import { ReferenceDocument } from 'src/app/model/referenceDocument';;
import { ReasonDialogComponent } from '../../shared/reason-dialog/reason-dialog.component';
import { ExecutionQ, ExecutionQTest, ExecutionQTestDeviations, ExecutionStatus } from 'src/app/model/execution';
import { ExecutionQService } from 'src/app/services/executionQ.service';
import { DialogDataConfirmSave } from '../protocol-edit/protocol-edit-confirm-save/protocol-q-edit-confirm-save.component';
import { ExecutionQEditConfirmSaveComponent } from './execution-edit-q-confirm-save/execution-edit-q-confirm-save.component';

import { TestQType } from 'src/app/model/testQType';
import { EquipmentQExecution } from 'src/app/model/equipment';
import { ProtocolQService } from 'src/app/services/protocolQ.service';
import { ExecutionEditEquipmentDialogComponent } from './execution-edit-q-equipment-dialog/execution-edit-q-equipment-dialog.component';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { ExecutionQEditTestComponent } from './execution-q-edit-test/execution-q-edit-test.component';
import { ExecutionQTestsService } from 'src/app/services/execution-q-tests.service';
import { ExecutionQEditAttachmentsComponent } from './execution-q-edit-attachments/execution-q-edit-attachments.component';
import { MatRadioChange } from '@angular/material/radio';
import { ProtocolAssignable, ProtocolQ, ProtocolQFilter } from '../../../model/protocol';
import { ProtocolQListComponent } from '../protocol-list/protocol-q-list.component';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { saveAs } from 'file-saver';
import { ClientShort } from '../../../model/clientShort';
import { ExecutionQTestDataObservations, ExecutionQTestDataOQ, ExecutionQTestData } from '../../../model/execution';
import { ExecutionEditQDeviationListComponent } from './execution-edit-q-deviation-list/execution-edit-q-deviation-list.component';
import { ExecutionQEditGenerateReportComponent } from './execution-q-edit-generate-report/execution-q-edit-generate-report.component';
import { ExecutionReportFilter } from '../../../model/attachment';
import { UserService } from '../../../services/user.service';
import { SignatureEditSignersComponent } from '../../signature/signature-edit-signers/signature-edit-signers.component';
import { DocumentListEnum } from '../../../utils/documentListUtils';
import { SignatureDocument, SignatureDocumentUsers } from '../../../model/signatureDocumentUsers';
import { SignatureDocumentsService } from '../../../services/signatureDocuments.service';
import { SignatureDocumentUsersService } from '../../../services/signatureDocumentUsers.service';
import { ExecutionQEditAuditComponent } from './execution-edit-q-audit/execution-edit-q-audit.component';
import { ExecutionEditQValidateExecutionComponent } from './execution-edit-q-validate-execution/execution-edit-q-validate-execution.component';
import { ExecutionQDeviationService } from '../../../services/executionQTestDeviation.service';
import { TestTypeEnum } from '../../../model/testQType';
import { QualificationTypeEnum } from '../../../model/verificationQType';
import { ExecutionQTestDataObservationsService } from '../../../services/executionQTestDataObservations.service';
import { v4 as uuid } from 'uuid';
import { ExecutionQTestDataOQService } from '../../../services/executionQTestDataOQ.service';
import { VerificationProcessingTypeEnum } from '../../../model/testQDataVerification';
import { ExecutionQTestDataMultipleService } from '../../../services/executionQTestDataMultiple.service';
import { ConfirmationDialogSignatureComponent } from '../../signature/confirmation-dialog-signature/confirmation-dialog-signature.component';
import { AppTypeEnum } from '../../../model/appType';


@Component({
  selector: 'app-execution-q-edit',
  templateUrl: './execution-q-edit.component.html',
  styleUrls: ['./execution-q-edit.component.scss'],
  standalone: false
})
export class ExecutionQEditComponent implements OnInit {

  @ViewChild(ExecutionQEditAuditComponent) auditTab: ExecutionQEditAuditComponent;
  @ViewChild('refDocTable', { static: true }) refDocTable: MatTable<any>;

  @ViewChildren('attachmentsComponent') attachmentsComponent: ExecutionQEditAttachmentsComponent;

  form: FormGroup;
  matcher = new MyErrorStateMatcher();
  execution: ExecutionQ;
  protocol = new ProtocolQ();
  clients: Client[];
  clientsFiltered: Client[];
  processes: GenericClass[];
  respField: User[];
  groupSelected: GroupTestQDataVerification[] = [];
  testQualificationTypeList: TestQualificationTypeShort[] = [];
  testQTypeChecked: TestQType[] = [];
  equipmentList: EquipmentQExecution[] = [];
  deviationList: ExecutionQTestDeviations[] = [];
  useExistingProtocol = true;
  displayedColumns = ['code', 'modDate', 'modUser'];
  totalItems: number;

  protocols: ProtocolQ[];
  protocolsFiltered: ProtocolQ[];
  protocolFilter = new ProtocolQFilter();

  clientsShort: ClientShort[];
  clientsShortFiltered: ClientShort[];

  currentUser: User;
  signatureDocument: SignatureDocumentUsers;

  isEnabledSignature: boolean = false;
  existsPendingSignature: boolean = false;

  testsPerformed = [{ id: QualificationTypeEnum.IQ, description: QualificationTypeEnum.IQ_DESCRIPTION }, { id: QualificationTypeEnum.OQ, description: QualificationTypeEnum.OQ_DESCRIPTION }, { id: QualificationTypeEnum.PQ, description: QualificationTypeEnum.PQ_DESCRIPTION }];

  @ViewChild('protocolAutocomplete') protocolAutocompleteInput: ElementRef;

  private destroy$ = new Subject<void>();
  private prevProtocolAutocomplete: Subscription;
  private loadingAutocompleteSubject = new BehaviorSubject<boolean>(false);
  public loadingAutocomplete$ = this.loadingAutocompleteSubject.asObservable();

  // eslint-disable-next-line @typescript-eslint/member-ordering
  displayedColsRefDoc = ['code', 'name', 'edit', 'delete'];

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ]
  }

  constructor(
    private clientService: ClientService,
    public dialog: MatDialog,
    private processService: ProcessService,
    private executionService: ExecutionQService,
    private executionQTestsService: ExecutionQTestsService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private usersService: UsersService,
    private testQualificationTypeService: TestQualificationTypeService,
    private protocolService: ProtocolQService,
    private userService: UserService,
    private signatureDocumentService: SignatureDocumentsService,
    private signatureDocumentUsersService: SignatureDocumentUsersService,
    private executionQTestDataObservationsService: ExecutionQTestDataObservationsService,
    private executionQTestDataOQService: ExecutionQTestDataOQService,
    private executionQTestDataMultipleService: ExecutionQTestDataMultipleService) {
    this.spinnerService.show();
    this.currentUser = this.userService.currentProfile;

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const id = params[Constants.FIELD_ID] as number;
      const idProtocolParam = +params[Constants.FIELD_ID_PROTOCOL];

      if (id == null) {
        this.cancel();
      }

      this.protocols = [];
      this.clients = [];

      this.execution = new ExecutionQ();
      if (+id === 0) {
        this.testQualificationTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: TestQualificationTypeShort[]) => {
          this.testQualificationTypeList = data;
        });

        this.clearProtocolFilter();
        this.protocolService.findAllAssignable(this.protocolFilter).pipe(takeUntil(this.destroy$)).subscribe(data => {
          if (data && data.content) {
            this.protocols = data.content as ProtocolQ[];
          } else if (data) {
            this.protocols = data as ProtocolQ[];
          } else {
            this.protocols = [];
          }
          this.protocolsFiltered = this.protocols.slice();
        });

        this.useExistingProtocol = true;
        if (idProtocolParam != null) {

          this.onProtocolChange(idProtocolParam);
        }

        this.clientService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: ClientShort[]) => this.loadClientsShort(data));

        this.spinnerService.hide();
      } else {

        this.executionService.findOne(id).pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionQ) => {
          if (result != null) {
            this.execution = result;

            this.initializeAttachmentsComponent();

            this.execution.referenceDocs?.sort((eq1, eq2) => {
              let order = eq1.id - eq2.id;

              if (order === 0) {
                order = eq1.id - eq2.id;
              }

              return order;
            });


            this.execution.equipments?.sort((eq1, eq2) => {
              let order = eq1.id - eq2.id;

              if (order === 0) {
                order = eq1.id - eq2.id;
              }

              return order;
            });
            this.equipmentList = result.equipments;

            this.deviationList = result.deviations;
            if (this.execution == null) {
              this.cancel();
              return;
            } else {
              this.spinnerService.show();
              this.signatureDocumentUsersService.findByUsernameIdDocumentAndIdType(this.currentUser.username, this.execution.id, DocumentListEnum.EXECUTION_QUALIFICATES).subscribe((result: SignatureDocumentUsers) => {
                if (result != null) {
                  this.isEnabledSignature = true;
                  this.signatureDocument = result;
                } else {
                  this.isEnabledSignature = false;
                  this.signatureDocument = null;
                  this.spinnerService.hide();
                }
              }, error => {
                console.log(error);
              });

              this.existsSignerPending();

              this.executionQTestsService.findAll(this.execution.id).pipe(takeUntil(this.destroy$))
                .subscribe((data: TestQualificationTypeShort[]) => {

                  data.forEach(item => {

                    let testQTypeChecked: TestQType[] = [];

                    item.testQTypes.forEach(test => {
                      if (test.checked) {
                        testQTypeChecked.push(test);
                      }
                    });
                    item.testQTypes = testQTypeChecked;
                  });
                  this.testQualificationTypeList = data;
                });

              this.spinnerService.hide();
            }
          } else {

            this.execution = null;
          }
        }, () => {

          this.execution = null;
          this.cancel();
        });
      }
    });
  }

  initializeAttachmentsComponent(): void {

    if (this.attachmentsComponent instanceof QueryList) {
      this.attachmentsComponent = this.attachmentsComponent.first as ExecutionQEditAttachmentsComponent;
    }

    if (this.attachmentsComponent) {
      this.attachmentsComponent.setIdExecution(this.execution.id);
      this.attachmentsComponent.setIdStatus(this.execution.idStatus);
    }
  }



  ngOnInit(): void {

    this.clients = [];
    this.processes = [];
    this.processService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClass[]) => this.processes = data);

    this.respField = [];
    this.usersService.findAllRespFromGroup().pipe(takeUntil(this.destroy$)).subscribe((data: User[]) => this.respField = data);

    this.clientService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: Client[]) => {
      this.clients = data;
      this.clientsFiltered = this.clients.slice();
    });

  }

  cancel(): void {
    void this.router.navigateByUrl('/qualificates/executions');
  }

  canEditDocumentCode(): boolean {
    const allowedStatuses = [ExecutionStatus.EN_EJECUCION, ExecutionStatus.PENDIENTE_FIRMA];

    return this.execution.id != null && allowedStatuses.includes(this.execution.idStatus);
  }

  onTabChange(event: MatTabChangeEvent): void {
    if (event.index === 1) {
      this.auditTab.getAudit();
    }
  }

  showAutomaticSign(): boolean {
    const current = this.currentUser;

    return this.canSign() && current.automaticSign && this.isEnabledSignature;
  }

  showManualSign(): boolean {
    const current = this.currentUser;

    return this.canSign() && current.manualSign && !this.isEnabledSignature && this.disabledSigned();
  }

  disabledSigned(): boolean {
    return this.existsPendingSignature;
  }

  showRevertSign(): boolean {
    return this.execution.idStatus === ExecutionStatus.FIRMADO;
  }

  saveExecution(): void {

    const errores: string[] = [];

    if (!this.execution?.idProtocol) {
      errores.push(this.translate.instant('executionEdit.protocol.error.empty') as string);
    }

    if (errores.length === 0) {
      if (this.execution.id == null) {
        this.save();
      } else {

        const showReason = (+this.execution.signedVersion) > 0;

        if (showReason) {

          const dialogRef = this.dialog.open(ExecutionQEditConfirmSaveComponent, {
            minWidth: '30vw',
            data: {
              execution: this.execution,
              reason: this.execution.reason
            }
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: DialogDataConfirmSave) => {
            if (result != null) {
              this.execution.reason = result.reason;
              this.save();
            }
          });

        } else {
          this.save();
        }

      }

    } else if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    }

  }

  openNewRefDoc(): void {
    const dialogRef = this.dialog.open(EditReferenceDocsComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        refDoc: new ReferenceDocument(),
        isEdit: false,
        disabled: false,
        idApp: AppTypeEnum.QUALIFICATES
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ReferenceDocument) => {


      if (result != null) {

        if (!this.execution.referenceDocs) {
          this.execution.referenceDocs = [];
        }

        this.execution.referenceDocs.push(result);

        this.refDocTable.renderRows();
      }
    });
  }

  editRefDoc(refDocIndex: number): void {

    const refDoc = this.execution.referenceDocs[refDocIndex];

    const dialogRef = this.dialog.open(EditReferenceDocsComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        refDoc: _.cloneDeep(refDoc),
        isEdit: true,
        disabled: false,
        idApp: AppTypeEnum.QUALIFICATES
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ReferenceDocument) => {

      if (result != null) {
        this.execution.referenceDocs[refDocIndex] = result;

        this.refDocTable.renderRows();
      }
    });
  }

  removeRefDoc(refDocIndex: number): void {
    this.execution.referenceDocs.splice(refDocIndex, 1);

    this.refDocTable.renderRows();
  }


  private save() {

    if (this.execution.idStatus === ExecutionStatus.PENDIENTE_FIRMA) {
      const dialogRef = this.dialog.open(ReasonDialogComponent, {
        minWidth: '40%',
        maxHeight: '95vh',
        data: {}
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
        if (result != null) {
          this.execution.reason = result;
          this.saveAll();
        }
      });
    } else {
      this.saveAll();
    }
  }

  private saveAll() {
    const isNew = this.execution.id == null;

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
      if (token != null) {

        this.spinnerService.show();
        this.executionService.save(this.execution, token).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQ) => {

          this.execution = res;
          this.reloadPage(this.execution.id);

          if (isNew) {
            this.snackBarService.sendSuccess(this.translate.instant('executionEditQ.form.create.ok') as string);
            void this.router.navigateByUrl(`qualificates/execution?id=${res.id}`);
          } else {
            this.snackBarService.sendSuccess(this.translate.instant('executionEditQ.form.update.ok') as string);
            void this.router.navigateByUrl(`qualificates/execution?id=${res.id}`);
          }

          this.spinnerService.hide();
        }, err => {
          if (err != null && err.error != null && typeof err.error === 'string') {
            this.snackBarService.sendError(err.error as string);
          } else if (isNew) {
            this.snackBarService.sendError(this.translate.instant('executionEditQ.form.create.error.generic') as string);
          } else {
            this.snackBarService.sendError(this.translate.instant('executionEditQ.form.update.error') as string);
          }

          this.spinnerService.hide();
        });

      } else {
        this.spinnerService.hide();
      }
    });
  }

  private reloadPage(idExecution) {

    if (idExecution == null) {
      idExecution = this.execution.id;
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    void this.router.navigateByUrl(`qualificates/execution?id=${idExecution}`);
  }

  openDialogEquipment(): void {
    const dialogRef = this.dialog.open(ExecutionEditEquipmentDialogComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        equipment: new EquipmentQExecution(),
        isEdit: false
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: EquipmentQExecution) => {
      if (result != null) {
        if (this.execution.equipments == null) {
          this.execution.equipments = [];
        }
        this.execution.equipments.push(result);
      }
    });
  }

  openDialogEditEquipment(idx: number): void {
    event.stopPropagation();

    const eq = this.execution.equipments[idx];

    const dialogRef = this.dialog.open(ExecutionEditEquipmentDialogComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        equipment: _.cloneDeep(eq),
        isEdit: true
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: EquipmentQExecution) => {
      if (result != null) {
        this.execution.equipments[idx] = result;
      }
    });
  }


  deleteEquipment(index: number): void {
    event.stopPropagation();

    const message = this.translate.instant('executionEditQ.dialog.equipment.form.confirmDelete') as string;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response === true) {
        if (index > -1) {
          this.execution.equipments.splice(index, 1);
        }
      }
    });

  }

  async validTestSelected(testType: TestQualificationTypeShort, test: TestQType) {
    try {
      const existCritical = await this.hasCriticalDeviations(test.id);

      if (existCritical && !this.isCompletedTest(test.id)) {
        this.snackBarService.sendError(this.translate.instant('executionEditQ.deviation.test.error') as string);
        return;
      }

      if (test.id === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION) {
        const rest = this.execution.executionQTests.filter(e =>
          this.testQualificationTypeList.some(etl =>
            etl.idQualificationType === QualificationTypeEnum.IQ &&
            etl.testQTypes?.some(tt => tt.id === e.idTestType)));

        if (rest && rest?.length > 0) {
          const resTest = rest.some(element => this.isCompletedTest(element.idTestType) === false);

          if (resTest) {
            const verifyTest = this.execution.executionQTests.find(e => e.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION);

            if (verifyTest) {
              this.executionQTestDataObservationsService.getAllByIdExecutionTest(verifyTest.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
                const resSomeComplete = item.some(vto => vto.notSelectedTest === true);
                if (!resSomeComplete) {
                  const message = this.translate.instant('executionEditQ.test.not_selected.confirm', { test: QualificationTypeEnum.IQ_DESCRIPTION.toUpperCase() }) as string;

                  const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });
                  dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
                    if (response === true) {
                      if (item && item.length > 0) {
                        const resSomeComplete = item.some(vto => vto.notSelectedTest === true);
                        if (resSomeComplete) {
                          this.createTestsSelected(test, false);
                        } else {
                          this.createTestsSelected(test, true);
                        }
                      } else {
                        this.createTestsSelected(test, true);
                      }
                    }
                  });
                } else {
                  this.createTestsSelected(test, false);
                }
              });
            } else {
              this.createTestsSelected(test, false);
            }
          } else {
            this.createTestsSelected(test, false);
          }
        } else {
          this.createTestsSelected(test, false);
        }
      } else if (test.id === TestTypeEnum.VERIFICATION_PERFORMANCE_TEST_QUALIFICATION_PERFORMANCE_TESTING) {
        const rest = this.execution.executionQTests.filter(e =>
          this.testQualificationTypeList.some(etl =>
            etl.idQualificationType === QualificationTypeEnum.OQ &&
            etl.testQTypes?.some(tt => tt.id === e.idTestType)));

        if (rest) {
          const resTest = rest.some(element => this.isCompletedTest(element.idTestType) === false);

          if (resTest) {
            const verifyTest = this.execution.executionQTests.find(e => e.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TEST_QUALIFICATION_PERFORMANCE_TESTING);

            if (verifyTest) {
              this.executionQTestDataObservationsService.getAllByIdExecutionTest(verifyTest.id).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestDataObservations[]) => {
                const resSomeComplete = item?.some(vto => vto.notSelectedTest === true);
                if (!resSomeComplete) {
                  const message = this.translate.instant('executionEditQ.test.not_selected.confirm', { test: QualificationTypeEnum.OQ_DESCRIPTION.toUpperCase() }) as string;

                  const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });
                  dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
                    if (response === true) {

                      if (item && item.length > 0) {
                        if (resSomeComplete) {
                          this.createTestsSelected(test, false);
                        } else {
                          this.createTestsSelected(test, true);
                        }
                      } else {
                        this.createTestsSelected(test, true);
                      }
                    }
                  });
                } else {
                  this.createTestsSelected(test, false);
                }
              });
            } else {
              this.createTestsSelected(test, false);
            }
          } else {
            this.createTestsSelected(test, false);
          }
        }
      } else {
        if (test.id !== TestTypeEnum.VERIFICATION_APPROVAL_DESIGN_QUALIFICATION) {
          const restIQ = this.execution.executionQTests.filter(e =>
            this.testQualificationTypeList.some(etl =>
              etl.idQualificationType === QualificationTypeEnum.IQ &&
              etl.testQTypes?.some(tt => tt.id === e.idTestType)));

          if (testType.idQualificationType === QualificationTypeEnum.IQ) {
            const testda = this.execution.executionQTests.find(eqt => eqt.idTestType === TestTypeEnum.VERIFICATION_APPROVAL_DESIGN_QUALIFICATION);

            if (testda) {
              if (!this.isCompletedTest(testda.idTestType)) {
                this.snackBarService.sendWarn(this.translate.instant("executionEditQ.test.valid", { test: testda.testDescription }));
              } else {
                this.createTestsSelected(test, false);
              }
            } else {
              this.createTestsSelected(test, false);
            }
          } else if (testType.idQualificationType === QualificationTypeEnum.OQ) {
            const testvp = this.execution.executionQTests.find(eqt => eqt.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION);
            if (testvp) {
              if (!this.isCompletedTest(testvp.idTestType)) {
                this.snackBarService.sendWarn(this.translate.instant("executionEditQ.test.valid", { test: testvp.testDescription }));
              } else if (restIQ && restIQ.length > 0) {
                const testCritical = this.execution.executionQTests.find(eqt => eqt.idTestType === TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT);

                if (testCritical) {
                  if (!this.isCompletedTest(testCritical.idTestType)) {
                    this.snackBarService.sendWarn(this.translate.instant("executionEditQ.test.valid", { test: testCritical.testDescription }));
                  } else {
                    this.createTestsSelected(test, false);
                  }
                }
              } else {
                this.createTestsSelected(test, false);
              }
            } else {
              this.createTestsSelected(test, false);
            }
          } else if (testType.idQualificationType === QualificationTypeEnum.PQ) {
            const testvp = this.execution.executionQTests.find(eqt => eqt.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TEST_QUALIFICATION_PERFORMANCE_TESTING);
            if (testvp) {
              if (!this.isCompletedTest(testvp.idTestType)) {
                this.snackBarService.sendWarn(this.translate.instant("executionEditQ.test.valid", { test: testvp.testDescription }));
              } else if (restIQ && restIQ.length > 0) {
                const testCritical = this.execution.executionQTests.find(eqt => eqt.idTestType === TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT);
                if (testCritical) {
                  if (!this.isCompletedTest(testCritical.idTestType)) {
                    this.snackBarService.sendWarn(this.translate.instant("executionEditQ.test.valid", { test: testCritical.testDescription }));
                  } else {
                    this.createTestsSelected(test, false);
                  }
                }
              } else {
                this.createTestsSelected(test, false);
              }
            } else {
              this.createTestsSelected(test, false);
            }
          }
        } else {
          this.createTestsSelected(test, false);
        }
      }

    } catch (error) {
      console.error('Error ejecutando la prueba:', error);
      this.snackBarService.sendError(this.translate.instant('executionEditQ.deviation.test.error') as string);
    }

  }
  createTestsSelected(test: TestQType, notSelectedTest: boolean = false): void {
    let isEdit = false;
    let isEditTest = false;
    let idStatus = this.execution.idStatus;
    // eslint-disable-next-line max-len

    const result = this.execution?.executionQTests?.find(e => e.idTestType === test?.id);
    if (result) {
      isEdit = true;
      if (result.executionQTestItemGroup) {
        isEditTest = true;
      }
    }
    const dialogRef = this.dialog.open(ExecutionQEditTestComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        idStatus,
        idItem: test.id,
        testQType: test,
        isEdit,
        isEditTest,
        data: _.cloneDeep(result),
        protocolNumber: this.execution?.protocolDocumentCode,
        notSelectedTest,
        tests: this.execution.executionQTests,
        deviations: this.execution.deviations,
        ex: this.execution
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(async (res: ExecutionQTest) => {
      if (res) {
        this.execution?.executionQTests?.filter(e => e.idTestType === test.id).forEach(d => {
          d.testDescription = res.testDescription;
          d.regUser = res.regUser;
          d.regDate = res.regDate;
          d.modUser = res.modUser;
          d.modDate = res.modDate;
          d.reason = res.reason;
          d.imageTest = res.imageTest;
          d.according = res.according;
          d.executionQTestItemGroup = res.executionQTestItemGroup;
          d.observation = res.observation;
          d.validatedDate = res.validatedDate;
          d.validatedUser = res.validatedUser;
          if (res.executionQTestOQVerification) {
            d.executionQTestOQVerification = res.executionQTestOQVerification;
          }
          if (res.executionQTestGeneralData) {
            d.executionQTestGeneralData = res.executionQTestGeneralData;
          }
          if (res.executionQTestEssayGroup) {
            d.executionQTestEssayGroup = res.executionQTestEssayGroup;
          }
          if (res.deviations) {
            d.deviations = res.deviations;
          }
          d.executionQTestInstrumentalUsed = res.executionQTestInstrumentalUsed;
          d.executionQTestCriticalInstrumentation = res.executionQTestCriticalInstrumentation;
        });

        /* Check IQ */
        const iqTestIdsIQ = this.testQualificationTypeList.filter(tqpl => tqpl.idQualificationType === QualificationTypeEnum.IQ).map(tqpl => tqpl.testQTypes.map(tqpt => tqpt.idExecutionTest)).reduce((acc, curr) => acc.concat(curr), []);
        const iqTestIdsOQ = this.testQualificationTypeList.filter(tqpl => tqpl.idQualificationType === QualificationTypeEnum.OQ).map(tqpl => tqpl.testQTypes.map(tqpt => tqpt.idExecutionTest)).reduce((acc, curr) => acc.concat(curr), []);
        const iqTestIdsPQ = this.testQualificationTypeList.filter(tqpl => tqpl.idQualificationType === QualificationTypeEnum.PQ).map(tqpl => tqpl.testQTypes.map(tqpt => tqpt.idExecutionTest)).reduce((acc, curr) => acc.concat(curr), []);

        if (iqTestIdsIQ.includes(res.id) && this.isCompletedTest(res.idTestType)) {
          let testInsll = this.execution.executionQTests.find(eeqt => eeqt.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION);
          if (testInsll && !this.isCompletedTest(testInsll.idTestType)) {
            if (testInsll.executionQTestOQVerification) {
              const uuidDevIncludes = [];
                const eoqFirst = testInsll.executionQTestOQVerification.find(extov => extov.uuidTest === res.uuidTest);
                if (eoqFirst) {
                  const resTest = this.execution.executionQTests.find(eeqt => eeqt.uuidTest === res.uuidTest);

                  if (!eoqFirst.regDate) {
                    let maxDate = this.getMaxDateVerification(res);
                    eoqFirst.regDate = maxDate;
                    eoqFirst.regUser = 'qloud';
                  } else {
                    eoqFirst.modDate = new Date();
                    eoqFirst.modUser = 'qloud';
                  }

                  eoqFirst.selectedResult = res.according;

                  if (res.idTestType === TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT) {
                     eoqFirst.uuidDeviation = resTest.deviations?.filter(edt => resTest.executionQTestCriticalInstrumentation?.some(eigivm => eigivm.uuidDeviation && eigivm.uuidDeviation?.includes(edt.uuid))).map(eee => eee.uuid);
                  } else {
                    eoqFirst.uuidDeviation = resTest.deviations?.filter(edt => resTest.executionQTestItemGroup?.some(eig => eig.executionQTestItems?.some(eigi => eigi.executionQTestItemVerification.some(eigiv => eigiv.executionQTestDataMultiple?.some(eigivm => eigivm.uuidDeviation && eigivm.uuidDeviation?.includes(edt.uuid)))))).map(eee => eee.uuid);
                  }
                  if (eoqFirst.uuidDeviation?.length > 0) {
                    let maxPosition = testInsll.executionQTestDataObservations != null ? testInsll.executionQTestDataObservations.map(item => item.position).filter(position => position !== null && position !== undefined).reduce((max, current) => (current > max ? current : max), 0) : 0;
                    for (let index = 0; index < eoqFirst.uuidDeviation?.length; index++) {
                      const element = resTest.deviations.find(td => eoqFirst.uuidDeviation.includes(td.uuid));

                      const existsObsDev = testInsll.executionQTestDataObservations?.find(eob => eob.uuidDeviation == element.uuid);
                      if (!uuidDevIncludes.includes(element.uuid) && !existsObsDev) {
                        const resUuid = uuid();
                        const isClosed = element.executionQTestDeviationData?.some(eqdd => eqdd.idType === 5 && eqdd.closed);
                        const dataValuation = element.executionQTestDeviationData.find(etd => etd.idType === 2);

                        const valuation = dataValuation ? dataValuation.valuation === 1 ? this.translate.instant("valuation.critical") : dataValuation.valuation === 2 ? this.translate.instant("valuation.mayor") : (dataValuation.valuation === 3 ? this.translate.instant("valuation.minor") : "") : "";

                        let obs = new ExecutionQTestDataObservations();
                        obs.idExecutionTest = testInsll.id;

                        if (isClosed) {
                          obs.description = this.translate.instant('executionEdit.test.deviation.obs.closed', { valuation: valuation, number: element.codeDeviation });
                        } else {
                          obs.description = this.translate.instant('executionEdit.test.deviation.obs.open', { valuation: valuation, number: element.codeDeviation });
                        }

                        obs.autogenerated = true;
                        obs.position = maxPosition + 1;

                        obs.uuid = resUuid;
                        obs.uuidDeviation = element.uuid;
                        uuidDevIncludes.push(element.uuid);

                        if (!eoqFirst.observations) {
                          eoqFirst.observations = [];
                        }
                        eoqFirst.observations.push(resUuid);

                        if (!testInsll.executionQTestDataObservations) {
                          testInsll.executionQTestDataObservations = [];
                        }
                          
                        const resObs = await this.saveObservation.call(this, obs);
                        testInsll.executionQTestDataObservations.push(resObs);
                      } else {
                        if (!eoqFirst.observations || !eoqFirst.observations.some(efob => efob === existsObsDev.uuid)) {
                          if (!eoqFirst.observations) {
                            eoqFirst.observations = [];
                          }
                          eoqFirst.observations.push(existsObsDev.uuid);
                        }
                      }
                    }
                  }

                  const robsOQObs = testInsll.executionQTestDataObservations?.filter(edd =>
                    testInsll.executionQTestOQVerification?.some(eig => eig.idTestType === res.idTestType && eig.uuidDeviation?.includes(edd.uuidDeviation))
                  );

                  if (robsOQObs && robsOQObs.length > 0) {
                    eoqFirst.observations = robsOQObs.map(rrs => rrs.uuid);
                  } else {
                    eoqFirst.observations = [];
                  }

                  this.executionQTestDataOQService.updateDataOQ(eoqFirst.idExecutionTest, eoqFirst).pipe(takeUntil(this.destroy$)).subscribe((resOQ: ExecutionQTestDataOQ) => {
                    const roqIndex = testInsll.executionQTestOQVerification.findIndex(efi => efi.id === resOQ.id);
                    if (roqIndex !== -1) {
                      testInsll.executionQTestOQVerification[roqIndex] = resOQ;
                    }
                  });
                }
            }

            let testComplete = true;
            for (let index = 0; index < testInsll.executionQTestOQVerification?.length; index++) {
              const elementovq = testInsll.executionQTestOQVerification[index];

              if (!this.isCompletedTest(elementovq.idTestType)) {
                testComplete = false;
              }
            }

            if (testComplete) {
              const resVerifDev = testInsll.executionQTestItemGroup.some(teig => teig.executionQTestItems?.some(teigi => teigi.executionQTestItemVerification?.some(teigiv => teigiv.processingType === VerificationProcessingTypeEnum.DEVIATION_INSTALLATION)));

              if (resVerifDev) {
                /* Validación IQ */
                let isAccordingDeviation = true;
                for (let indexOQVef = 0; indexOQVef < testInsll.executionQTestOQVerification?.length; indexOQVef++) {
                  const elementOQVef = testInsll.executionQTestOQVerification[indexOQVef];
                  if (elementOQVef) {
                    const exDev = this.execution.deviations.find(ed => elementOQVef.uuidDeviation?.includes(ed.uuid));
                    if (exDev) {
                      const isCritical = exDev.executionQTestDeviationData?.some(eqdd => eqdd.idType === 2 && eqdd.valuation === 1);

                      if (isCritical) {
                        isAccordingDeviation = false;
                      }
                    }
                  }
                }

                if (testInsll.executionQTestItemGroup && testInsll.executionQTestItemGroup?.length > 0) {
                  for (let indexGroup = 0; indexGroup < testInsll.executionQTestItemGroup.length; indexGroup++) {
                    const elementGroup = testInsll.executionQTestItemGroup[indexGroup];

                    for (let indexItem = 0; indexItem < elementGroup.executionQTestItems?.length; indexItem++) {
                      const elementItem = elementGroup.executionQTestItems[indexItem];

                      for (let indexVerification = 0; indexVerification < elementItem.executionQTestItemVerification?.length; indexVerification++) {
                        const elementVerification = elementItem.executionQTestItemVerification[indexVerification];

                        if (elementVerification.processingType === VerificationProcessingTypeEnum.DEVIATION_INSTALLATION) {
                          elementVerification.executionQTestDataMultiple.forEach(dm => {
                            dm.automatic = true;
                            dm.obtainedResult = isAccordingDeviation ? this.translate.instant('common.no') : this.translate.instant('common.yes');
                            if (!dm.regUser) {
                              dm.regUser = 'qloud';
                              dm.regDate = this.getMaxDateOQVerification(testInsll.executionQTestOQVerification, this.execution.executionQTests);
                            } else {
                              dm.modUser = 'qloud';
                              dm.regDate = new Date();
                            }
                            dm.selectedResult = isAccordingDeviation ? 'according': 'not_according';

                            this.executionQTestDataMultipleService.updateDataMultiple(this.execution.id, testInsll.id, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
                              dm = item;
                            });
                          });
                        }
                      }
                    }
                  }
                }
              }        
            }

            let obsResulted: ExecutionQTestDataObservations[] = [];
            this.execution.executionQTests
            .filter(eeex => iqTestIdsIQ.includes(eeex.id))
              .forEach(eeep => {
                let robs = null;
                if (eeep.idTestType === TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT) {
                  robs = testInsll.executionQTestDataObservations?.filter(edd =>
                    edd.uuidDeviation?.includes(edd.uuidDeviation)
                  );
                } else {
                  robs = testInsll.executionQTestDataObservations?.filter(edd =>
                    eeep.executionQTestItemGroup?.some(eig =>
                      eig.executionQTestItems?.some(eigi =>
                        eigi.executionQTestItemVerification?.some(eigiv =>
                          eigiv.executionQTestDataMultiple?.some(eigivm =>
                            eigivm.uuidDeviation?.includes(edd.uuidDeviation)
                          )
                        )
                      )
                    )
                  );
                }

                if (robs && robs.length > 0) {
                  obsResulted.push(...robs);
                }
            });

            if (obsResulted.length > 0) {
              obsResulted.forEach((erd, erdIndex) => {
                erd.position = erdIndex;
              });
            }
            testInsll.executionQTestDataObservations = obsResulted;
                             
            this.executionQTestsService.updateTest(this.execution.id, testInsll).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTest) => {
              const testIndex = this.execution.executionQTests.findIndex(eeqt => eeqt.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION);
              this.execution.executionQTests[testIndex] = item;
            });
          }
        } else if (iqTestIdsOQ.includes(res.id) && !this.isCompletedTest(res.idTestType)) {
          let testInsll = this.execution.executionQTests.find(eeqt => eeqt.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TEST_QUALIFICATION_PERFORMANCE_TESTING);
            if (testInsll && !this.isCompletedTest(testInsll.idTestType)) {
              if (testInsll.executionQTestOQVerification) {
                const uuidDevIncludes = [];
                const eoqFirst = testInsll.executionQTestOQVerification.find(extov => extov.idTestType === res.idTestType);
                if (eoqFirst) {
                  const resTest = this.execution.executionQTests.find(eeqt => eeqt.idTestType === res.idTestType);

                  if (!eoqFirst.regDate) {
                    let maxDate = null;
                    if (resTest.executionQTestEssayGroup?.length > 0) {
                      maxDate = this.getMaxDateEssay(res);
                    } else {
                      maxDate = this.getMaxDateVerification(res);
                    }

                    if (maxDate) {
                      eoqFirst.regDate = maxDate;
                      eoqFirst.regUser = 'qloud';
                    }
                  } else {
                    eoqFirst.modDate = new Date();
                    eoqFirst.modUser = 'qloud';
                  }

                  eoqFirst.selectedResult = res.according;
                  eoqFirst.uuidDeviation = resTest.deviations?.filter(edt => resTest.executionQTestItemGroup?.some(eig => eig.executionQTestItems?.some(eigi => eigi.executionQTestItemVerification.some(eigiv => eigiv.executionQTestDataMultiple?.some(eigivm => eigivm.uuidDeviation && eigivm.uuidDeviation?.includes(edt.uuid)))))).map(eee => eee.uuid);

                   if (eoqFirst.uuidDeviation?.length > 0) {
                    let maxPosition = testInsll.executionQTestDataObservations != null ? testInsll.executionQTestDataObservations.map(item => item.position).filter(position => position !== null && position !== undefined).reduce((max, current) => (current > max ? current : max), 0) : 0;
                    for (let index = 0; index < resTest.deviations?.length; index++) {
                      const element = resTest.deviations[index];

                      const existsObsDev = testInsll.executionQTestDataObservations?.find(eob => eob.uuidDeviation == element.uuid);
                      if (!uuidDevIncludes.includes(element.uuid) && !existsObsDev) {
                        const resUuid = uuid();
                        const isClosed = element.executionQTestDeviationData?.some(eqdd => eqdd.idType === 5 && eqdd.closed);
                        const dataValuation = element.executionQTestDeviationData.find(etd => etd.idType === 2);

                        const valuation = dataValuation ? dataValuation.valuation === 1 ? this.translate.instant("valuation.critical") : dataValuation.valuation === 2 ? this.translate.instant("valuation.mayor") : (dataValuation.valuation === 3 ? this.translate.instant("valuation.minor") : "") : "";

                        let obs = new ExecutionQTestDataObservations();
                        obs.idExecutionTest = testInsll.id;

                        if (isClosed) {
                          obs.description = this.translate.instant('executionEdit.test.deviation.obs.closed', { valuation: valuation, number: element.codeDeviation });
                        } else {
                          obs.description = this.translate.instant('executionEdit.test.deviation.obs.open', { valuation: valuation, number: element.codeDeviation });
                        }

                        obs.autogenerated = true;
                        obs.position = maxPosition + 1;

                        obs.uuid = resUuid;
                        obs.uuidDeviation = element.uuid;
                        uuidDevIncludes.push(element.uuid);

                        if (!eoqFirst.observations) {
                          eoqFirst.observations = [];
                        }
                        eoqFirst.observations.push(resUuid);

                        if (!testInsll.executionQTestDataObservations) {
                          testInsll.executionQTestDataObservations = [];
                        }
                          
                        const resObs = await this.saveObservation.call(this, obs);
                        testInsll.executionQTestDataObservations.push(resObs);
                      } else {
                        if (!eoqFirst.observations || !eoqFirst.observations.some(efob => efob === existsObsDev.uuid)) {
                          if (!eoqFirst.observations) {
                            eoqFirst.observations = [];
                          }
                          eoqFirst.observations.push(existsObsDev.uuid);
                        }
                      }
                    }
                  }

                  const robsOQObs = testInsll.executionQTestDataObservations?.filter(edd =>
                    testInsll.executionQTestOQVerification?.some(eig => eig.uuidDeviation?.includes(edd.uuidDeviation))
                  );

                  if (robsOQObs && robsOQObs.length > 0) {
                    eoqFirst.observations = robsOQObs.map(rrs => rrs.uuid);
                  } else {
                    eoqFirst.observations = [];
                  }

                  this.executionQTestDataOQService.updateDataOQ(eoqFirst.idExecutionTest, eoqFirst).pipe(takeUntil(this.destroy$)).subscribe((resOQ: ExecutionQTestDataOQ) => {
                    const roqIndex = testInsll.executionQTestOQVerification.findIndex(efi => efi.id === resOQ.id);
                    if (roqIndex !== -1) {
                      testInsll.executionQTestOQVerification[roqIndex] = resOQ;
                    }
                  });

              }
            }

            let testComplete = true;
            for (let index = 0; index < testInsll.executionQTestOQVerification?.length; index++) {
              const elementovq = testInsll.executionQTestOQVerification[index];

              if (!this.isCompletedTest(elementovq.idTestType)) {
                testComplete = false;
              }
            }

            if (testComplete) {
              const resVerifDev = testInsll.executionQTestItemGroup.some(teig => teig.executionQTestItems?.some(teigi => teigi.executionQTestItemVerification?.some(teigiv => teigiv.processingType === VerificationProcessingTypeEnum.DEVIATION_WORKING)));

              if (resVerifDev) {
                /* Validación IQ */
                let isAccordingDeviation = true;
                for (let indexOQVef = 0; indexOQVef < testInsll.executionQTestOQVerification?.length; indexOQVef++) {
                  const elementOQVef = testInsll.executionQTestOQVerification[indexOQVef];
                  if (elementOQVef) {
                    const exDev = this.execution.deviations.find(ed => elementOQVef.uuidDeviation?.includes(ed.uuid));
                    if (exDev) {
                      const isCritical = exDev.executionQTestDeviationData?.some(eqdd => eqdd.idType === 2 && eqdd.valuation === 1);

                      if (isCritical) {
                        isAccordingDeviation = false;
                      }
                    }
                  }
                }

                if (testInsll.executionQTestItemGroup && testInsll.executionQTestItemGroup?.length > 0) {
                  for (let indexGroup = 0; indexGroup < testInsll.executionQTestItemGroup.length; indexGroup++) {
                    const elementGroup = testInsll.executionQTestItemGroup[indexGroup];

                    for (let indexItem = 0; indexItem < elementGroup.executionQTestItems?.length; indexItem++) {
                      const elementItem = elementGroup.executionQTestItems[indexItem];

                      for (let indexVerification = 0; indexVerification < elementItem.executionQTestItemVerification?.length; indexVerification++) {
                        const elementVerification = elementItem.executionQTestItemVerification[indexVerification];

                        if (elementVerification.processingType === VerificationProcessingTypeEnum.DEVIATION_WORKING) {
                          elementVerification.executionQTestDataMultiple.forEach(dm => {
                            dm.obtainedResult = isAccordingDeviation ? this.translate.instant('common.yes') : this.translate.instant('common.no');
                            dm.regUser = 'qloud';
                            dm.regDate = this.getMaxDateOQVerification(testInsll.executionQTestOQVerification, this.execution.executionQTests);
                            dm.selectedResult = isAccordingDeviation ? 'according': 'not_according';

                            this.executionQTestDataMultipleService.updateDataMultiple(this.execution.id, testInsll.id, dm).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTestData) => {
                              dm = item;
                            });
                          });
                        }
                      }
                    }
                  }
                }
              }        
            }

            let obsResulted: ExecutionQTestDataObservations[] = [];
            this.execution.executionQTests
            .filter(eeex => iqTestIdsIQ.includes(eeex.id))
              .forEach(eeep => {
                let robs = null;
                if (eeep.idTestType === TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT) {
                  robs = testInsll.executionQTestDataObservations?.filter(edd =>
                    edd.uuidDeviation?.includes(edd.uuidDeviation)
                  );
                } else {
                  robs = testInsll.executionQTestDataObservations?.filter(edd =>
                    eeep.executionQTestItemGroup?.some(eig =>
                      eig.executionQTestItems?.some(eigi =>
                        eigi.executionQTestItemVerification?.some(eigiv =>
                          eigiv.executionQTestDataMultiple?.some(eigivm =>
                            eigivm.uuidDeviation?.includes(edd.uuidDeviation)
                          )
                        )
                      )
                    )
                  );
                }

                if (robs && robs.length > 0) {
                  obsResulted.push(...robs);
                }
            });

            if (obsResulted.length > 0) {
              obsResulted.forEach((erd, erdIndex) => {
                erd.position = erdIndex;
              });
            }
            testInsll.executionQTestDataObservations = obsResulted;
                             
            this.executionQTestsService.updateTest(this.execution.id, testInsll).pipe(takeUntil(this.destroy$)).subscribe((item: ExecutionQTest) => {
              const testIndex = this.execution.executionQTests.findIndex(eeqt => eeqt.idTestType === TestTypeEnum.VERIFICATION_PERFORMANCE_TESTING_INSTALLATION_QUALIFICATION);
              this.execution.executionQTests[testIndex] = item;
            });
          }
        }
      }
    });
  }

  onUseExistingProtocolChange(event: MatRadioChange): void {
    this.useExistingProtocol = event.value as boolean;

    if (this.useExistingProtocol) {
      this.execution.idClient = null;
      this.execution.idProcess = null;
      this.execution.projectNo = null;
      this.execution.usernameProjectManager = null;
    } else {
      this.protocol = null;
      this.execution.idProtocol = null;
    }
  }

  lookupProtocol($event): void {
    if (this.prevProtocolAutocomplete) {
      this.prevProtocolAutocomplete.unsubscribe();
    }

    this.loadingAutocompleteSubject.next(true);

    const filter = new ProtocolQFilter();

    filter.autocomplete = $event.target.value as string;
    filter.pageIndex = 0;
    filter.pageSize = 10;
    filter.sortBy = 'name';
    filter.sortDirection = 'asc';

    this.prevProtocolAutocomplete = this.protocolService.findAllAssignable(filter).pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data && data.content) {
        this.protocols = data.content as ProtocolQ[];
      } else if (data) {
        this.protocols = data as ProtocolQ[];
      } else {
        this.protocols = [];
      }

      this.protocolsFiltered = this.protocols.slice();

      this.loadingAutocompleteSubject.next(false);
    });
  }

  displayProtocol(prot: ProtocolAssignable): string {
    if (!prot) {
      return '';
    }

    const documentCode = prot?.documentCode != null ? prot.documentCode : '';
    const client = prot?.nameClient != null ? prot.nameClient : '';

    return documentCode.concat(' ').concat(client);
  }

  openSearchProtocol(): void {
    event.stopPropagation();

    this.loadingAutocompleteSubject.next(true);

    const dialogRef = this.dialog.open(ProtocolQListComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        isList: false
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: number) => {
      this.loadingAutocompleteSubject.next(false);
      if (result != null) {
        this.onProtocolChange(result);
      }
    });
  }

  onProtocolChange(event: MatAutocompleteSelectedEvent | number): void {
    this.spinnerService.show();

    let idProtocol: number = null;
    if (event instanceof MatAutocompleteSelectedEvent) {
      idProtocol = (event.option.value as ProtocolAssignable)?.id;
    } else {
      idProtocol = event;
    }

    if (idProtocol == null || isNaN(idProtocol)) {
      this.spinnerService.hide();

      return;
    }

    this.execution.idProtocol = idProtocol;

    this.protocolService.findOneShort(idProtocol).pipe(takeUntil(this.destroy$)).subscribe((prot: ProtocolQ) => {
      this.protocol = prot;

      this.protocolAutocompleteInput.nativeElement.value = prot.documentCode;
      this.execution.usernameProjectManager = prot.usernameProjectManager;
      this.execution.projectNo = prot.projectNo;
      this.execution.idProcess = prot.idProcess;
      this.execution.idClient = prot.idClient;
      //this.execution.executionQTests = this.convertTest(this.protocol.protocolQTest);

      this.spinnerService.hide();
    });
  }

  downloadProtocolPdf(): void {
    this.spinnerService.show();

    this.protocolService.downloadPdfVersion(this.execution.idProtocol, this.execution.originalProtocolVersion)
      .pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
        const name = this.execution.protocolDocumentCode + ' v.' + this.execution.originalProtocolVersion.toString().padStart(2, '0');

        saveAs(res, this.translate.instant('executionEditQ.files.report', { name }) as string);
        this.spinnerService.hide();
      }, () => {
        this.snackBarService.sendError(this.translate.instant('executionEditQ.form.downloadPdf.error.notFound') as string);
        this.spinnerService.hide();
      });
  }

  canAdd(): boolean {
    return this.execution.id != null;
  }

  enableEditTest(): boolean {
    const allowedStatuses = [ExecutionStatus.EN_EJECUCION];

    return allowedStatuses.includes(this.execution.idStatus)
  }

  private clearProtocolFilter() {
    this.protocolFilter = new ProtocolQFilter();

    this.protocolFilter.pageSize = 10000;
  }

  loadClientsShort(res: ClientShort[]): void {
    this.clientsShort = res;
    this.clientsShortFiltered = this.clientsShort.slice();
  }

  isCompletedTest(idTestType: number): boolean {
    let res = [];
    const testResult = this.execution.executionQTests.find(e => e.idTestType === idTestType);

    if (testResult) {

      for (let indexGroup = 0; indexGroup < testResult.executionQTestItemGroup?.length; indexGroup++) {
        const group = testResult.executionQTestItemGroup[indexGroup];
        for (let index = 0; index < group.executionQTestItems?.length; index++) {
          const element = group.executionQTestItems[index];

          for (let indextiv = 0; indextiv < element.executionQTestItemVerification.length; indextiv++) {
            const elementtiv = element.executionQTestItemVerification[indextiv];

            for (let indextdm = 0; indextdm < elementtiv.executionQTestDataMultiple?.length; indextdm++) {
              const elementTDM = elementtiv.executionQTestDataMultiple[indextdm];
              if (!elementTDM.regUser) {
                res.push(true);
              } else {
                res.push(false);
              }
            }
          }
        }
      }

      if (idTestType === TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT) {
        if (testResult.executionQTestCriticalInstrumentation && testResult.executionQTestCriticalInstrumentation?.length > 0) {
          for (let indexCal = 0; indexCal < testResult.executionQTestCriticalInstrumentation?.length; indexCal++) {
            const cal = testResult.executionQTestCriticalInstrumentation[indexCal];
            if (!cal.regUser) {
              res.push(true);
            } else {
              res.push(false);
            }
          }
        } else {
          res.push(true);
        }

      }
      return !res.find(e => e === true);
    } else {
      return false;
    }
  }

  showExecute(): boolean {
    if (this.execution.idStatus == null) {
      return false;
    }

    const validStatuses = [ExecutionStatus.EN_EJECUCION];

    return validStatuses.includes(this.execution.idStatus);
  }

  execute(): void {
    const errors = this.errorExecute();

    if (errors.length !== 0) {
      const error = errors.join('\n');
      this.snackBarService.sendError(error);

      return;
    }

    const resValidateDev = this.validateDeviation();
    if (resValidateDev) {
      const message = this.translate.instant('executionEditQ.test.not_complete.confirm') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response === true) {
          this.requestReason((reason) => {
            this.execution.reason = reason;
            this.spinnerService.show();
            this.executionService.validateTest(this.execution.id, resValidateDev, reason).pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQ) => {
              this.spinnerService.hide();
              this.snackBarService.sendSuccess(this.translate.instant('executionEditQ.form.save.ok') as string);
              this.reloadPage(res.id);
            }, error => {
              this.spinnerService.hide();
              this.snackBarService.sendError(this.translate.instant('executionEditQ.form.save.error') as string);
              console.log(error);
            });
          });
        }
      });
    } else {
      this.showDialogValidate();
    }
  }


  errorExecute(): string[] {
    let errors = [];
    for (let indexTest = 0; indexTest < this.execution.executionQTests?.length; indexTest++) {
      const elementTest = this.execution.executionQTests[indexTest];

      for (let indexDev = 0; indexDev < elementTest.deviations?.length; indexDev++) {
        const elementDev = elementTest.deviations[indexDev];

        const isCritical = elementDev.executionQTestDeviationData.some(e => e.idType === 2 && e.valuation === 1);
        if (isCritical) {
          /*const isNotResolvedData = elementDev.executionQTestDeviationData.some(e => e.idType === 5);
          if (isNotResolvedData) {
            const isNotResolved = elementDev.executionQTestDeviationData.some(e => e.idType === 5 && !e.resolved);
            if (isNotResolved) {
              errors.push(this.translate.instant('executionEditQ.deviation.error') as string);
            }
          } else {
            errors.push(this.translate.instant('executionEditQ.deviation.error') as string);
          }*/
        } else {
          const isNotContinue = elementDev.executionQTestDeviationData.some(e => e.idType === 2 && !e.qualificationContinue);

          if (isNotContinue) {
            errors.push(this.translate.instant('executionEditQ.deviation.error') as string);
          }
        }

      }
    }

    return errors;
  }


  async hasCriticalDeviations(idTestType: number): Promise<any> {
    const iqTestIdsIQ = this.testQualificationTypeList.filter(tqpl => tqpl.idQualificationType === QualificationTypeEnum.IQ).map(tqpl => tqpl.testQTypes.map(tqpt => tqpt.idExecutionTest)).reduce((acc, curr) => acc.concat(curr), []);

    /*const test = this.execution.executionQTests.filter(e => iqTestIdsIQ.includes(e.id));

    if (test) {
      return  test?.some(t =>
        t.deviations?.some(dev =>
          dev.executionQTestDeviationData?.some(dd =>
            (dd.idType === 2 && (!dd.qualificationContinue || dd.valuation === 1)) ||
            (dd.idType === 5 && !dd.resolved)
          )
        )
      );
    } else {
      return false;
    }*/
   return false;
  }

  showDeviationSelected(idTestExecution: number) {
    const test = this.execution.executionQTests.find(e => e.id === idTestExecution);
    const dialogRef = this.dialog.open(ExecutionEditQDeviationListComponent, {
      minWidth: '70%',
      maxHeight: '95vh',
      data: {
        deviations: test.deviations,
        protocolNumber: this.execution.protocolDocumentCode,
        idStatus: this.execution.idStatus,
        idExecution: this.execution.id,
        idExecutionTest: idTestExecution,
        executionNumber: this.execution.documentCode
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((res: ExecutionQTestDeviations[]) => {
    });

  }

  downloadPdf(): void {
    const dialogRef = this.dialog.open(ExecutionQEditGenerateReportComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {
        execution: this.execution,
        protocol: this.protocol,
        reason: this.execution.reason
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionReportFilter) => {
      if (result != null) {
        this.execution.conclusions = result.conclusions;
      }
    });
  }

  showBack(): boolean {
    if (this.execution.idStatus == null) {
      return false;
    }

    if (this.execution.idStatus == null) {
      return false;
    }

    const profile = this.userService.currentProfile;

    if (profile == null) {
      return false;
    }

    const validStatuses = [ExecutionStatus.PENDIENTE_FIRMA];

    return validStatuses.includes(this.execution.idStatus);
  }

  calculateBack(): void {

    if (this.execution.idStatus === ExecutionStatus.PENDIENTE_FIRMA) {
      this.invalidateByDoc();
    } else {
      this.snackBarService.sendError(this.translate.instant('executionEdit.form.status.error.notAllowed') as string);
    }

  }

  invalidateByDoc(): void {
    const errors = [];

    if (errors.length !== 0) {
      const error = errors.join('\n');
      this.snackBarService.sendError(error);

      return;
    }

    this.requestReason((reason: string) => {
      this.requestSign((token: string) => {
        if (token != null) {
          this.spinnerService.show();

          this.executionService.invalidateByDoc(this.execution.id, reason, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.snackBarService.sendSuccess(this.translate.instant('executionEditQ.form.status.back.ok', { status }) as string);

            this.reloadPage(this.execution.id);

            this.spinnerService.hide();

          }, () => {
            this.snackBarService.sendError(this.translate.instant('executionEdit.form.status.advance.error.generic') as string);

            this.spinnerService.hide();
          });

        } else {
          this.spinnerService.hide();
        }
      });
    });
  }

  isValidateTest(test: TestQType): boolean {
    const testResult = this.execution.executionQTests.find(e => e.idTestType === test.id);

    if (testResult) {
      return testResult.validatedDate != null;
    } else {
      return false;
    }
  }


  validateDeviation(): number {
    let validateTest = [];
    let lastTrueIndex: TestQType;
    let foundFalse = false;

    for (let index = 0; index < this.testQualificationTypeList.length; index++) {
      const element = this.testQualificationTypeList[index];
      if (element.testQTypes != null) {
        for (let indexTest = 0; indexTest < element.testQTypes.length; indexTest++) {
          const elementTest = element.testQTypes[indexTest];
          const testResult = this.isCompletedTest(elementTest.id);
          validateTest.push(testResult);
          if (!foundFalse && testResult === true) {
            lastTrueIndex = elementTest;
          }

          if (testResult === false && !foundFalse) {
            foundFalse = true
          }
        }
      }
    }

    if (validateTest.some(e => e === false)) {
      return lastTrueIndex.id;
    } else {
      return null;
    }
  }

  private getErrorsSign(): string[] {
    const errores: string[] = [];
    let foundValidated = false;
    let foundCompleted = false;
    for (let index = 0; index < this.execution.executionQTests.length; index++) {
      const element = this.execution.executionQTests[index];
      if (!this.isCompletedTest(element.idTestType) && !foundCompleted) {
        errores.push(this.translate.instant('protocolEditQ.test.error'));
        foundCompleted = true
      }

      if (!element.validatedDate && !foundValidated) {
        errores.push(this.translate.instant('protocolEditQ.test.validated.error'));
        foundValidated = true
      }
    }
    return errores;
  }

  private canSign(): boolean {
    if (this.execution.idStatus == null) {
      return false;
    }

    const profile = this.userService.currentProfile;

    if (profile == null) {
      return false;
    }

    const validStatuses = [ExecutionStatus.PENDIENTE_FIRMA];

    return validStatuses.includes(this.execution.idStatus);
  }

  showSignature(): boolean {
    const current = this.currentUser;

    return this.canSign() && current.automaticSign && current.admin;
  }

  prepareToSign(): void {
    const errores = this.getErrorsSign();

    if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    } else {
      const message = this.translate.instant('signers.sign.user.valid') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response) {
          this.requestSign((token: string) => {
            this.saveSignatureByUser(token);
          });
        }
      });
    }
  }

  prepareToSigner() {
    const errores = this.getErrorsSign();

    if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    } else {
      this.openDialogSigner();
    }
  }

  openDialogSigner() {
    const dialogRef = this.dialog.open(SignatureEditSignersComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        idDocument: this.execution.id,
        documentType: DocumentListEnum.EXECUTION_QUALIFICATES,
        nDocument: this.execution.documentCode,
        idClient: this.execution.idClient,
        currentVersion: this.execution.currentVersion
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        this.existsSignerUsernamePending();
        this.snackBarService.sendSuccess(this.translate.instant('signers.dialog.ok'))
      }
    });
  }

  saveSignatureByUser(token: string) {
    this.spinnerService.show();
    this.signatureDocument.idStatus = 2;
    this.signatureDocumentService.saveDocumentUser(this.signatureDocument, token).subscribe((result: SignatureDocumentUsers) => {
      if (result) {
        this.spinnerService.hide();

        this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.signature.complete.ok') as string);    
        if (result.message) {
          const dialogRef = this.dialog.open(ConfirmationDialogSignatureComponent, {
            data: {
              canCancel: false,
              canOk: false,
              icon: true,
              html: true,
              messageOk: this.translate.instant('common.continue'),
              idSignature: this.signatureDocument.idSignature
            }
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
            this.reloadPage(null);
          });
        } else {
          this.reloadPage(null);
        }
      
      } else {
        this.spinnerService.hide();
        this.snackBarService.sendError(this.translate.instant('protocolEdit.signature.complete.error') as string);
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

  existsSignerUsernamePending() {
    this.spinnerService.show();

    this.signatureDocumentUsersService.findByUsernameIdDocumentAndIdType(this.currentUser.username, this.execution.id, DocumentListEnum.EXECUTION_QUALIFICATES).subscribe((result: SignatureDocumentUsers) => {
      if (result != null) {
        this.isEnabledSignature = true;
        this.signatureDocument = result;
        this.spinnerService.hide();
      } else {
        this.isEnabledSignature = false;
        this.signatureDocument = null;
        this.spinnerService.hide();
      }
    }, error => {
      console.log(error);
      this.spinnerService.hide();
    });
  }

  existsSignerPending() {
    this.spinnerService.show();

    this.signatureDocumentService.findByIdDocumentAndIdType(this.execution.id, DocumentListEnum.EXECUTION_QUALIFICATES, this.execution.currentVersion, true).subscribe((result: SignatureDocument) => {
      if (result != null) {
        this.existsPendingSignature = true;
        this.spinnerService.hide();
      } else {
        this.existsPendingSignature = false;
        this.spinnerService.hide();
      }
    }, error => {
      console.log(error);
      this.spinnerService.hide();
    });
  }

  showTextSigner(): string {
    return this.existsPendingSignature ? 'button.editSigner' : 'button.newSigner';
  }

  showBtnDeviation(idTestType: number): boolean {
    const resTest = this.execution.executionQTests.find(e => e.idTestType === idTestType);
    const existsDev = resTest.executionQTestItemGroup?.some(group =>
      group.executionQTestItems?.some(item =>
        item.executionQTestItemVerification?.some(verification =>
          verification.executionQTestDataMultiple?.some(data =>
            data.uuidDeviation !== null && data.uuidDeviation?.length > 0))));

    const existsDevCritical = resTest.executionQTestCriticalInstrumentation?.some(critical =>
      critical.uuidDeviation !== null && critical.uuidDeviation?.length > 0);

    if (existsDev || existsDevCritical) {
      return true;
    } else {
      return false;
    }
  }

  getMaxDateVerification(res: ExecutionQTest): Date {
    let maxDate = null;
    if (res.idTestType !== TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT) {
      for (let i = 0; i < res.executionQTestItemGroup?.length; i++) {
        const reig = res.executionQTestItemGroup[i];

        for (let j = 0; j < reig.executionQTestItems?.length; j++) {
          const reige = reig.executionQTestItems[j];

          for (let k = 0; k < reige.executionQTestItemVerification?.length; k++) {
            const reigev = reige.executionQTestItemVerification[k];

            for (let l = 0; l < reigev.executionQTestDataMultiple?.length; l++) {
              const edm = reigev.executionQTestDataMultiple[l];
              const date = new Date(edm.regDate);

              if (!maxDate || date > maxDate) {
                maxDate = date;
              }
            }
          }
        }
      }
    } else {
      for (let i = 0; i < res.executionQTestCriticalInstrumentation?.length; i++) {
        const reig = res.executionQTestCriticalInstrumentation[i];
        const date = new Date(reig.regFc);

        if (!maxDate || date > maxDate) {
          maxDate = date;
        }
      }
    }

    return maxDate;
  }

  getMaxDateOQVerification(res: ExecutionQTestDataOQ[], tests: ExecutionQTest[]): Date {
    let maxDate = null;

    res.forEach(resOQ => {
      const resTest = tests.find(rt => rt.idTestType === resOQ.idTestType);
      if (resTest.idTestType !== TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT) {
        for (let i = 0; i < resTest.executionQTestItemGroup?.length; i++) {
          const reig = resTest.executionQTestItemGroup[i];

          for (let j = 0; j < reig.executionQTestItems?.length; j++) {
            const reige = reig.executionQTestItems[j];

            for (let k = 0; k < reige.executionQTestItemVerification?.length; k++) {
              const reigev = reige.executionQTestItemVerification[k];

              for (let l = 0; l < reigev.executionQTestDataMultiple?.length; l++) {
                const edm = reigev.executionQTestDataMultiple[l];
                const date = new Date(edm.regDate);

                if (!maxDate || date > maxDate) {
                  maxDate = date;
                }
              }
            }
          }
        }
      }
    });

    return maxDate;
  }

  getMaxDateEssay(res: ExecutionQTest): Date {
    let maxDate = null;
    for (let i = 0; i < res.executionQTestEssayGroup?.length; i++) {
        const reig = res.executionQTestEssayGroup[i];

        for (let j = 0; j < reig.essayValues?.length; j++) {
          const reige = reig.essayValues[j];

          for (let k = 0; k < reige.sensors?.length; k++) {
            const reigev = reige.sensors[k];

            if (reigev && reigev?.data) {
              for (let l = 0; l < reigev.data?.length; l++) {
                const edm = reigev.data[l];
                const date = new Date(edm.date);

                if (!maxDate || date > maxDate) {
                  maxDate = date;
                }
              }
            }
            
          }
        }
      }
    return maxDate;
  }

  private saveExecutionCallback(callback: () => void) {
    this.spinnerService.show();

    this.executionService.save(this.execution, null).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.spinnerService.hide();
      callback();
    }, err => {
      if (err != null && err.error != null && typeof err.error === 'string') {
        this.snackBarService.sendError(err.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('executionEdit.form.status.advance.error.generic') as string);
      }
      this.spinnerService.hide();
    });
  }

  private showDialogValidate() {
    const dialog = this.dialog.open(ExecutionEditQValidateExecutionComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        execution: this.execution,
        protocol: this.protocol
      }
    });

    dialog.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        this.snackBarService.sendSuccess(this.translate.instant('executionEditQ.form.save.ok') as string);
        this.reloadPage(this.execution.id);
      } else {
        this.snackBarService.sendError(this.translate.instant('executionEditQ.form.save.error') as string);
      }
    });
  }

  private requestReason(callback: (reason: string) => void) {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

  private requestSign(callback: (token: string) => void) {
    this.spinnerService.hide();

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

  private async saveObservation(obs: ExecutionQTestDataObservations) {
    const res = await firstValueFrom(this.executionQTestDataObservationsService.save(obs));
    return res;
  }
}


